import { put } from 'redux-saga/effects';

import { Insurance } from 'constants/routes';
import { updatePagesPatching } from 'store/insurance/actions';
import { ACTIONS } from 'store/insurance/constants';
import { CreatePage } from 'store/insurance/helpers';
import {
  insuranceStageGetCustomers,
  insuranceStageUpdateInsurerCustomer,
  insuranceStageUpdateOwnerCustomer,
} from 'store/insurance/sagas';

const { ROUTE_NAMES } = Insurance;

const PAGE_NAME = ROUTE_NAMES.POLICYHOLDER;

export const insurancePageUpdatePolicyholder = new CreatePage({
  action: ACTIONS.UPDATE_POLICYHOLDER,
  after: function* () {
    yield put(updatePagesPatching({ [PAGE_NAME]: false }));
  },
  before: function* () {
    yield put(updatePagesPatching({ [PAGE_NAME]: true }));
  },
  handler: function* (_, { runStage }) {
    yield* runStage(insuranceStageUpdateOwnerCustomer);
    yield* runStage(insuranceStageUpdateInsurerCustomer);
    yield* runStage(insuranceStageGetCustomers);
  },
  name: PAGE_NAME,
}).watcher;
